import { render } from "./player.vue?vue&type=template&id=40fad4da&scoped=true"
import script from "./player.vue?vue&type=script&lang=js"
export * from "./player.vue?vue&type=script&lang=js"

import "./player.vue?vue&type=style&index=0&id=40fad4da&scoped=true&lang=css"

import exportComponent from "C:\\Project\\VuePro\\classCloud\\kclass-index-mtzls\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40fad4da"]])

export default __exports__